import React, { useContext, useState } from "react";
import { FormTextInput } from "../../../Components/FormTextInput";
import NewButton from "../../../NewComponents/NewButton";

import { NotificationContext } from "../../../Context/NotificationContext";
import { auth, emailAuthProvider } from "../../../firebase.config";

const ChangePass = ({password}) => {
  const { showNotification } = useContext(NotificationContext);
  const [CurrentPass, setCurrentPass] = useState(password ?? "");
  const [NewPass, setNewPass] = useState("");
  const [ConfirmNewPass, setConfirmNewPass] = useState("");

  const [saveBtn, setSaveBtn] = useState("Save");

  const [error, setError] = useState("");

  const handleSave = (e) => {
    if (CurrentPass.length < 6) {
      setError("current");
      return;
    }
    if (NewPass.length < 6) {
      setError("new");
      return;
    }
    if (CurrentPass.length < 6 || ConfirmNewPass !== NewPass) {
      setError("confirm");
      return;
    }
    setSaveBtn("Saving...");

    const user = auth.currentUser;
    var credential = emailAuthProvider.credential(
      user.email,
      CurrentPass
    );

    user
      .reauthenticateWithCredential(credential)
      .then(() => {
        user
          .updatePassword(NewPass)
          .then(() => {
            showNotification(
              "Password Changed",
              "Your password has been changed successfully.",
              "success"
            );
          })
          .catch((error) => {
            console.log(error);
           showNotification(
              "Error",
              "The password is invalid or the user does not have a password.. Please, try again. If it persists, contact Support.",
              "error"
            );
            // ...
          });
      })
      .catch((error) => {
        console.log(error);
        showNotification(
          "Error",
          "The password is invalid or the user does not have a password. Please, try again. If it persists, contact Support.",
          "error"
        );
      })
      .finally(() => {
        setSaveBtn("Save");
      });
  };

  return (
    <>
      <div className="accountSettingInputWrap">
        <FormTextInput
          disabled={saveBtn === "Saving..."}
          placeholder="Current Password"
          incorrect={error === "current"}
          value={CurrentPass}
          onChange={setCurrentPass}
          password
          showPasswordIcon
        />
        <FormTextInput
          disabled={saveBtn === "Saving..."}
          placeholder="New Password"
          incorrect={error === "new"}
          value={NewPass}
          onChange={setNewPass}
          password
          showPasswordIcon
        />
        <FormTextInput
          disabled={saveBtn === "Saving..."}
          incorrect={
            error === "confirm" ||
            (ConfirmNewPass !== "" &&
              (ConfirmNewPass.length < 6 || ConfirmNewPass !== NewPass))
          }
          placeholder="Confirm new Password"
          value={ConfirmNewPass}
          onChange={setConfirmNewPass}
          password
          showPasswordIcon
        />
      </div>

      <NewButton
        text={saveBtn}
        disabled={
          saveBtn === "Saving..." ||
          CurrentPass < 6 ||
          NewPass < 6 ||
          ConfirmNewPass < 6 ||
          ConfirmNewPass !== NewPass
        }
        onClick={handleSave}
      />
    </>
  );
};

export default ChangePass;
